import moment from 'moment-timezone';
import momentDurationFormatSetup from 'moment-duration-format';
import { getAppConfig } from 'larasnap';

momentDurationFormatSetup(moment);

let formats;
const getFormats = () =>
    formats
        ? formats
        : (formats = {
              datetime: getAppConfig('datetime_format'), // This needs to be defined before 'date' and 'time'
              date: getAppConfig('date_format'),
              time: getAppConfig('time_format'),
          });

const resolveCustomFormats = (formats, format) =>
    Object.keys(formats).reduce(
        (format, c) => format.replace(c, formats[c]),
        format,
    );

const baseFormat = moment.prototype.format;
moment.prototype.format = function (format = '') {
    return baseFormat.bind(this)(resolveCustomFormats(getFormats(), format));
};

moment.prototype.isSameOrBetween = function (start, end) {
    return this.isBetween(start, end, undefined, '[]');
};

moment.prototype.isSameOrWithin = function (start, end) {
    return this.isBetween(start, end, undefined, '()');
};

moment.time = function (val) {
    return moment(val, 'HH:mm:ss');
};

export default moment;
